
import { ref, Ref, computed } from "vue";
import { TOPO_GENERAL } from "@/interfaces/SmartLink/Topology";
import { STRINGS } from "@/interfaces/SmartLink/General";
import { vuetify } from "@/plugins/vuetify";
import { COLOR } from "@/constants/colors";

/* eslint-disable */
// STORE
import store from "@/store";
const projectName = computed(() => store.state.projectName);

export function getNowTime() {
  let nowTime = new Date().getTime();
  if (projectName.value === "SmartLinkMasterFront") {
    nowTime = new Date("2024-05-01 17:15:00").getTime();
  }

  if (projectName.value === "SmartLinkDEMO") {
    nowTime = new Date("2026-04-30 14:30:00").getTime();
  }

  //Cambiar esto
  // if (ip === "http://192.168.2.223:4159/api/") {
  //   nowTime = new Date("2025-03-01 00:00:00").getTime();
  // }
  return nowTime;
}

export function getFinDate() {
  let finDate = new Date();
  if (projectName.value === "SmartLinkMasterFront") {
    finDate = new Date("2024-05-31 17:15:00");
  }

  if (projectName.value === "SmartLinkDEMO") {
    finDate = new Date("2026-04-30 14:30:00");
  }

  // // cambiar esto
  // if (ip === "http://192.168.2.223:4159/api/") {
  //   finDate = new Date("2025-03-27 23:45:00");
  // }
  return finDate;
}

export function getLatitude(latitud: string) {
  let finalLatitud = 0;
  const gradeLat = parseFloat((latitud ?? "0").slice(0, 2));
  const minuteLat = parseFloat((latitud ?? "0").slice(2, -1)) / 60;
  finalLatitud = gradeLat + minuteLat;
  return finalLatitud;
}

export function getLongitude(longitud: string) {
  let finalLongitud = 0;
  const gradeLng = parseFloat((longitud ?? "0").slice(0, 3));
  const minuteLng = parseFloat((longitud ?? "0").slice(3, -1)) / 60;
  finalLongitud = (gradeLng + minuteLng) * -1;
  return finalLongitud;
}

export function getLatLngPrev(lat: string, lng: string) {
  let position = { lat: 0, lng: 0 };
  if (
    projectName.value === "SmartLinkAntamina" ||
    projectName.value === "SmartLinkAntucoya"
  ) {
    position = { lat: parseFloat(lat), lng: parseFloat(lng) };
  }
  if (
    projectName.value === "SmartLinkMaster" ||
    projectName.value === "SmartLinkMasterFront"
  ) {
    const latSM = `${lat.slice(0, 2)}.${lng.slice(2)}`;
    const lngSM = `${lat.slice(0, 4)}.${lng.slice(4)}`;
    position = { lat: parseFloat(latSM), lng: parseFloat(lngSM) };
  }
  return position;
}

export function getTimeZone() {
  let timezone = "";
  if (
    projectName.value === NAME_PROJECT.hcg ||
    projectName.value === NAME_PROJECT.raos
  ) {
    timezone = "America/Bogota";
  }
  if (
    projectName.value === NAME_PROJECT.cananea ||
    projectName.value === NAME_PROJECT.demo ||
    projectName.value === NAME_PROJECT.nacozari
  ) {
    timezone = "America/Hermosillo";
  }
  if (projectName.value === NAME_PROJECT.collahuasi) {
    timezone = "America/Santiago";
  }
  return timezone;
}

/**
 * Recibe el parametro que quiere que se muestre
 * Ejemplo: 'tipo', 'subtipo', 'name', etc
 * Retorna el objeto {
 *      ip : valor
 * }
 * @param selecteType
 * @returns
 */
export function getInfoByIP(selecteType: string) {
  const allDataInfo: TOPO_GENERAL[] = store.state.arrayItemsByStatus;
  const finalNameByIP: Ref<STRINGS> = ref({});
  const finalType: keyof TOPO_GENERAL =
    (selecteType as keyof TOPO_GENERAL) ?? "ip";
  const allItems: TOPO_GENERAL[] = allDataInfo;

  allItems.forEach((item: TOPO_GENERAL) => {
    if (!finalNameByIP.value[item.ip]) {
      finalNameByIP.value[item.ip] = "";
    }
    finalNameByIP.value[item.ip] = item[`${finalType}`];
  });

  return finalNameByIP.value;
}

/**
 * INTERFACE para getOptionsInGraphs()
 */
interface Tooltip {
  formatter?: (this: { value?: number; y?: number; x?: number }) => string;
  valueDecimals?: number;
  shared?: boolean;
  // split? : boolean;
}

//captura el color del fondo y de las letras
const colorBG = computed(
  () => vuetify.theme.global.current.value.colors.bgtopology,
);
const colorText = computed(
  () => vuetify.theme.global.current.value.colors.colorText,
);

// importacion del i18n (idiomatico es/en)
import i18n from "../../i18n/i18n";
import { NAME_PROJECT } from "@/constants/labels";
const day = computed(() => i18n.global.t("labels.day"));
const week = computed(() => i18n.global.t("labels.week"));
const month = computed(() => i18n.global.t("labels.month"));

/**
 * Función que está diseñada para retornar el objeto de la configuración de los gráficos.
 * Recibe varios parámetros con lógica ya hecha anteriormente, aquí solo lo junta.
 * @param typeChart Tipo de Chart (area, line, column, etc)
 * @param serie Los Valores de las Series con toda su información
 * @param title Si se recibe '', no se mostrará el titulo
 * @param subtitle Si se recibe '', no se mostrará el titulo
 * @param legendEnabled Habilita la leyenda de ser nesesario
 * @param height El tamaño del gráfico (el 'default' es 460)
 * @param tooltip Si recibe '{}', mostrará el tooltipo por defecto, sino sera uno personalizado
 * @param yaxis Si recibe '{}', no mostrará ningun valor en el yAxis, sino sera uno personalizado
 * @returns OBJETO de Opciones del CHART (no pude ponerle un TIPO)
 */
export function getOptionsInGraphs(
  typeChart: string,
  serie: any,
  title: string,
  subtitle: string,
  legendEnabled: boolean,
  height: number,
  tooltip: Tooltip,
  yaxis: any,
) {
  const finalOptions = {
    chart: {
      type: typeChart,
      height: height,
      backgroundColor: colorBG,
      style: { color: colorText },
    },
    legend: {
      enabled: legendEnabled,
      align: "center",
      layout: "horizontal",
      verticalAlign: "bottom",
      itemStyle: {
        color: colorText,
        fontWeight: "bold",
      },
    },
    credits: {
      enabled: false,
    },
    tooltip: tooltip,
    title: {
      text: title,
      style: { color: colorText },
    },
    subtitle: {
      text: subtitle,
      style: { color: colorText },
    },
    // navigator: {
    //     maskFill: 'rgba(102, 133, 194, 0.2)', // Usa un color semitransparente simple para reducir cálculos
    //     maskInside: false, // Desactiva la máscara externa
    //     oppsite: true,
    // },
    xAxis: {
      labels: {
        style: { color: colorText },
      },
    },
    yAxis: yaxis,
    plotOptions: {
      area: {
        stacking: "normal",
        lineColor: "#FFFFFF",
        lineWidth: 1,
        marker: {
          lineWidth: 1,
          lineColor: "#FFFFFF",
        },
      },
    },
    series: serie,
    rangeSelector: {
      allButtonsEnabled: true,
      buttons: [
        { type: "hour", count: 1, text: `1 Hora` },
        { type: "day", count: 1, text: `1 ${day.value}` },
        { type: "day", count: 2, text: `2 ${day.value}s` },
        { type: "week", count: 1, text: `1 ${week.value}` },
        { type: "month", count: 1, text: `1 ${month.value}` },
      ],
      buttonTheme: { width: 60 },
      selected: 0,
    },
    exporting: { enabled: false },
    time: {
      useUTC: false
    },
  };

  return finalOptions;
}

export function getFinalDate(date: Date) {
  const getHisYear = date.getFullYear();
  const getHisMonth = date.getMonth() + 1;
  const getHisDay = date.getDate();
  const finalDate = `${getHisDay}/${getHisMonth}/${getHisYear}`;

  return finalDate;
}

export function getArrayOrSingle(valor: any, indexNumber: number) {
  const finalValor: number =
    valor === undefined
      ? 0
      : (typeof valor).toUpperCase() == "OBJECT" && valor !== null
        ? parseFloat(valor[indexNumber])
        : parseFloat(valor);

  return finalValor;
}

export function getStatus(latency: number) {
  const finalStatus = ref("");

  if (latency > 0 && latency <= 100) finalStatus.value = "ok";
  if (latency > 100 && latency <= 500) finalStatus.value = "alert";
  if (latency > 500) finalStatus.value = "alarm";
  if (latency === -1) finalStatus.value = "down";

  return finalStatus.value;
}

export function getColorStatus(latency: number) {
  const finalStatus = ref("");

  if (latency > 0 && latency <= 100) finalStatus.value = COLOR.green;
  if (latency > 100 && latency <= 500) finalStatus.value = COLOR.yellow;
  if (latency > 500) finalStatus.value = COLOR.red;
  if (latency === -1) finalStatus.value = COLOR.greyfake;

  return finalStatus.value;
}
